export default __webpack_public_path__ + "static/media/about-home.572b59e0.png";